// Home section content ---------------------------------
export const home_section = {
    month: 'May',
    date: '24-25 | 2027',
    venue:'Vienna | Austria',
    title: ' Advanced Medical Practices Conclave',
    subTitle: 'MEDICLAVE - 2027'
}

// About Section Content ----------------------------
export const about_section = {
  title: 'Innovations in Global Health: Bridging Gaps through Technology & Collaboration',
  points: [
    'Explores the impact of artificial intelligence and big data on medical diagnostics',
    'Using digital health tools and telemedicine to enhance patient-centered approaches',
    'Ethical challenges associated with new technologies, like gene editing, AI, and data privacy',
    'The global response to infectious diseases and strategies for collaboration & pandemic preparedness.'
  ],
  button: {
    label: 'Know More',
    link: '/about-mediclave'
  }
};

// Executive panel members section -------------------------------
export const executive_panel = {
  title: 'Meet Our Esteemed Executive Panel',
  description:
    'Our executive panel comprises visionary leaders and industry pioneers who bring deep expertise and strategic insight to guide our mission in advancing global health innovation.',
  members: [
    {
      name: 'Hassan El-Tamimi',
      title: 'Founder & Prof.',
      country: 'UAE',
      image: 'ima', // Replace with actual image path or URL
    },
    // {
    //   name: 'Mohamed Hosni',
    //   title: 'CEO & Prof.',
    //   country: 'UK',
    //   image: 'ima', // Replace with actual image path or URL
    // },
    {
      name: 'Chrysoula I. Liakou',
      title: 'Founder & Prof.',
      country: 'Greece',
      image: 'ima', // Replace with actual image path or URL
    },
    {
      name: 'Dana York',
      title: 'Founder & Prof.',
      country: 'United States',
      image: 'ima', // Replace with actual image path or URL
    },
  ],
  button: {
    label: 'Know More',
    link: '/about-mediclave'
  }
};

// Tracks data section ---------------------------------------
export const mediclave_tracks = {
  title: 'Mediclave - Tracks',
  topics: [
    {
      title: 'AI in Healthcare',
      image: 'ai-healthcare.webp', // replace with actual image path or URL
    },
    {
      title: 'Telemedicine & Digital Health',
      image: 'telemedicine.webp',
    },
    {
      title: 'Cardiology',
      image: 'cardiology.webp',
    },
    {
      title: 'Gynecology',
      image: 'gynecology.webp',
    },
    {
      title: 'Pediatrics',
      image: 'pediatrics.webp',
    },
    {
      title: 'Emergency Medicine',
      image: 'emergency-medicine.webp',
    },
    {
      title: 'Oncology',
      image: 'oncology.webp',
    },
    {
      title: 'Gastroenterology',
      image: 'gastroenterology.webp',
    },
    {
      title: 'Genetic Disorder',
      image: 'genetic-disorder.webp',
    },
    {
      title: 'Infectious Diseases',
      image: 'infectious-diseases.webp',
    },
    {
      title: 'Endocrinology',
      image: 'endocrinology.webp',
    },
    {
      title: 'Rheumatology',
      image: 'rheumatology.webp',
    },
    {
      title: 'Mental Health',
      image: 'mental-health.webp',
    },
    {
      title: 'Pain Management',
      image: 'pain-management.webp',
    },
    {
      title: 'Nutrition and Metabolism',
      image: 'nutrition-metabolism.webp',
    },
    {
      title: 'Addiction Medicine',
      image: 'addiction-medicine.webp',
    },
    {
      title: 'Geriatrics',
      image: 'geriatrics.webp',
    },
    {
      title: "Women's Health & Midwifery",
      image: 'womens-health.webp',
    },
    {
      title: 'Cosmetic Surgery',
      image: 'public-health.webp',
    },
    {
      title: 'Vaccines',
      image: 'vaccines.webp',
    },
  ],
  buttons: [
    {
      label: 'Read More',
      link: '/mediclave-tracks',
    },
    {
      label: 'Submit Abstract',
      link: '/submit-abstract',
    },
  ],
};

// Orators data section -----------------------------------------
export const mediclave_orators = {
  title: 'Mediclave - Orators',
  description:
    'Renowned experts from across the globe sharing insights and leading the conversation at Mediclave.',
  orators: [
    // {
    //   name: 'Prof. Mohamed Hosni',
    //   title: 'CEO & Prof.',
    //   country: 'United Kingdom',
    //   image: 'mohamed-hosni.webp', // replace with actual image path or URL
    // },
    {
      name: 'Prof. Chrysoula I. Liakou',
      title: 'CEO & Prof.',
      country: 'Greece',
      image: 'chrysoula-liakou.webp',
    },
    {
      name: 'Prof. Joaquin Cayon',
      title: 'CEO & Prof.',
      country: 'Spain',
      image: 'joaquin-cayon.webp',
    },
    {
      name: 'Prof. Mohammed Abu-Ragheef',
      title: 'CEO & Prof.',
      country: 'Sweden',
      image: 'mohammed-abu-ragheef.webp',
    },
  ],
  button: {
    label: 'View All',
    link: '/orators',
  },
};

// Venue Data Section -----------------------------------------
export const conference_venue = {
  title: 'Proposed Conference Venue',
  names: [
    'Novotel Valencia Lavant',
    'City of Arts and Sciences',
    'Valencia Cathedral',
    'La Lonja de la Seda (UNESCO)',
    'El Carmen district',
    'Oceanogràfic',
    'L’Umbracle & Mya nightlife',
    'Bioparc Valencia',
  ],
  images: [
    'novotel-valencia.webp',
    'city-of-arts.webp',
    'valencia-cathedral.webp',
    'la-lonja.webp',
    'el-carmen.webp',
    'oceanografic.webp',
  ],
  button: {
    label: 'View all',
    link: '/venue',
  },
};

//Event Partners Data -----------------------------------------
export const partners = {
  title: 'Mediclave - Event Partners',
  names: [
    'Partner 1',
    'Partner 2',
    'Partner 3',
    'Partner 4',
    'Partner 5',
    'Partner 6',
    'Partner 7',
    'Partner 8',
    'Partner 9',
  ],
  button: {
    label: 'Become a Partner',
    link: '/become-a-partner',
  },
};


